import React from "react";

import withLocalisationProvider from "features/localisation/withLocalisationProvider";
import { useLocalisedMessage } from "features/localisation";

import CordRight from "./components/CordRight";
import CordLeft from "./components/CordLeft";
import Shards from "./components/Shards";

import styles from "./OfflineScreen.module.scss";
import { messages } from "./translations";

export function OfflineScreen() {
  const heading = useLocalisedMessage(messages.heading);
  const description = useLocalisedMessage(messages.description);

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <CordLeft className={styles.cord} />
        <Shards />
        <CordRight className={styles.cord} />
      </div>
      <div>
        <h1>{heading}</h1>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default withLocalisationProvider(OfflineScreen);
